import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { BorrowerLeadGenerationTool } from "borrower-lead-generation-tool";
import '../../css/startToday.css';

export default function StartToday() {
    const [showForm, setShowForm] = useState(false);
    const imgCDNURL = process.env.REACT_APP_MYDIVORCELENDER_CDN_URL;

    const handleClose = () => setShowForm(false);

    // stores the input field reference in a way that allows us to conditionally render
    // content or scroll to the element on button click.
    const [node, setNode] = useState(null);
    useEffect(() => {
        if (node) {
            const inputs = document.querySelectorAll(".blg-row-1 .form-control");
            inputs.forEach((input) => {
                if (input.placeholder.toLowerCase().includes("name")) {
                    input.placeholder = `Your Name`;
                } else if (input.placeholder.toLowerCase() === "email address") {
                    input.placeholder = `Your ${input.placeholder}`;
                } else if (input.placeholder.toLowerCase() === "telephone number") {
                    input.placeholder = "Your Phone Number";
                } else if (
                    input.placeholder.toLowerCase() ===
                    "tell us about your needs and special circumstances"
                ) {
                    input.placeholder = "Your Message";
                }
            });
        }
    }, [node]);
    // watches for changes in the form.
    const formRef = useCallback((node) => {
        // node refers to the name input field in the BorrowerLeadGenerationTool
        setNode(node);
    }, []);

    return (
        <>
            <Container className="startTodayContainer">
                <Row className="pt-3 mb-3">
                    <Col className="text-center">
                        <div className="startTodayBox" onClick={() => setShowForm(true)}>
                            <h5 className="startTodayText">
                                Start Today
                            </h5>
                        </div>
                    </Col>
                </Row>
                <Row className="pt-3 mb-3">
                    <Col sm={12} className="text-center mb-3">
                        <img src={imgCDNURL + "computer-icon.png"} className="img-fluid" />
                    </Col>
                    <Col sm={12} className="text-center">
                        <h5 className="startTodayContactText">
                            Email me at{" "}
                            <a href="mailto:divorcelender@swmc.com" className="startTodayContactLinks">
                                divorcelender@swmc.com
                            </a> or
                        </h5>
                    </Col>
                </Row>
                <Row className="pt-3 mb-3">
                    <Col sm={12} className="text-center mb-3">
                        <img src={imgCDNURL + "mobile-icon.png"} className="img-fluid" />
                    </Col>
                    <Col sm={12} className="text-center">
                        <h5 className="startTodayContactText">
                            Call{" "}
                            <a href="tel:+18445029935" className="startTodayContactLinks">
                                (844) 502-9935
                            </a> today!
                        </h5>
                    </Col>
                </Row>
            </Container>
            <Modal
                id="startTodayBorrowerLeadForm"
                size="lg"
                show={showForm}
                onHide={handleClose}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Schedule a Strategy Call
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <BorrowerLeadGenerationTool
                        leadSource="POPLEAD010"
                        branch="641"
                        loanOfficerUid="P358"
                        statesDomain="swmc.com"
                        loanPurposeKeyword="PURCHASE"
                        ref={formRef}
                        mainBtnName={`Let's connect`}
                        domainNameConsent="swmc.com"
                        language="en"
                    />
                </Modal.Body>
            </Modal>
        </>
    );
}